import React from 'react';

export const useApplication = () => {
	const app = React.useContext(AppContext);
	return app;
};

export const useUserdata = () => {
	const app = useApplication();
	const [data, setData] = React.useState({
		...app.userdata,
	});

	React.useEffect(() => {

		const changeHandler = (newData) => {
			setData(newData);
		};

		app.addChangeListener?.(changeHandler);

		return () => {
			app.removeChangeListener?.(changeHandler);
		};
	}, [app]);

	return data;
};

export const AppContext = React.createContext();
